import { IconProps } from "./types"

const path = [
  "M15.4087 13.0269C16.4127 13.0269 18 11.2455 18 9.84784V3.45795C18 1.62972 16.4689",
  "0.141846 14.5864 0.141846H8.00854C6.56923 0.141846 5.27557 1.02978 4.79102 2.34998C4.37805",
  "3.48113 6.16563 4.0765 6.57668 2.96775C6.79229 2.37839 7.36859 1.98233 8.00854 1.98233H14.5864C15.4236",
  "1.98233 16.1054 2.64466 16.1054 3.45795V9.84784C16.1054 10.4695 15.6971 11.0293 15.0904 11.2393C14.109",
  "11.5808 14.3958 13.0269 15.4087 13.0269ZM9.88022 17.6276H3.38324C1.51845 17.6276 0 16.1536 0 14.3415V8.03019C0",
  "6.21812 1.51845 4.74417 3.38324 4.74417H9.88022C11.745 4.74417 13.2629 6.21812 13.2629 8.03019V14.3415C13.2629",
  "16.1536 11.7444 17.6276 9.88022 17.6276ZM3.38324 6.5841C2.56266 6.5841 1.89462 7.23306 1.89462 8.03019V14.3415C1.89462",
  "15.1387 2.56266 15.7876 3.38324 15.7876H9.88022C10.7008 15.7876 11.3688 15.1387 11.3688 14.3415V8.03019C11.3688 7.23306",
  "10.7008 6.5841 9.88022 6.5841H3.38324Z",
].join(" ")

export const IconCopy = ({
  className,
  color = "#000",
  height = 19,
  width = 18,
}: IconProps) => (
  <svg
    className={className}
    fill={color}
    height={height}
    viewBox="0 0 18 19"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clipRule="evenodd" d={path} fillRule="evenodd" />
  </svg>
)
